import LockOpen from '@mui/icons-material/LockOpen';
import { Button, useNotify, useRefresh, useUpdate } from 'react-admin';
import { DataProviderResource } from 'src/constants';

interface UnlockUserButtonProps {
  id: string;
}

export const UnlockUserButton = ({ id }: UnlockUserButtonProps) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const [update, { isLoading }] = useUpdate();

  const onLock = async () => {
    update(
      DataProviderResource.UnlockUser,
      {
        id,
      },
      {
        onSuccess: () => {
          notify('User successfully unlocked.', { type: 'success' });
        },
        onSettled: () => {
          refresh();
        },
        onError: err => {
          notify(`Failed to unlock user. Received: ${err}`, {
            type: 'error',
          });
        },
      },
    );
  };

  return (
    <Button label={'Unlock'} onClick={onLock} disabled={isLoading} style={{ marginTop: '8px' }}>
      <LockOpen />
    </Button>
  );
};
